import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { checkTenantNotification } from '../api';

export function useCheckTenantNotification(onCheck?: () => void) {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const checkNotification = async (notificationId: number) => {
    setLoading(true);

    try {
      await checkTenantNotification(notificationId);
      onCheck?.();
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, checkNotification };
}
